import { SegmentDetailType } from 'features/Segmentation/@types/SegmentCreateEdit'
import apiServices from 'config/apiServiceApiGateway'

const { Get, Post, Put } = apiServices

export type GetSegmentCreateEditResponseType = {
  error: {
    code: 0
    status: false
    message: ''
  }
  data: SegmentDetailType
}

export type GetSegmentDetailRequestType = {
  segmentId: string
}
export const getSegmentDetail = ({ segmentId }: GetSegmentDetailRequestType) =>
  Get<GetSegmentCreateEditResponseType, true>({
    url: `/segmentation/internal/v2/segment/${segmentId}`,
  })

export const getSegmentABDetail = (segmentId: string) =>
  Get<GetSegmentCreateEditResponseType, true>({
    url: `/segmentation/internal/v2/segment/ab-group/${segmentId}`,
  })

export type GetPrifileSegmentOptionsResponseType = {
  error: {
    code: 0
    status: false
    message: ''
  }
  data: {
    id: string
    name: string
  }[]
}

export const getProfileSegmentOptions = () =>
  Get<GetPrifileSegmentOptionsResponseType, true>({
    url: `/segmentation/internal/v1/profile`,
  })

export type PostCreateSegmentRequestType = {
  data: {
    segment_name: string
    segment_type: string
    group_id: string
    group_ab_id: string
    segment_start_date: string
    segment_end_date: string
    profile: {
      enable: boolean
      id: string
      name?: string
    }
    purchase: {
      product_ids: number[]
      start_date: string
      end_date: string
      category_l1_ids: number[]
      category_l2_ids: number[]
      brand_ids: number[]
      is_all_time: boolean
      interval: number
    }
    registration: {
      start_date: string
      interval: number
      end_date: string
      is_all_time: boolean
    }
    min_count_order: number
    max_count_order: number
    is_include_new_register: boolean
    is_real_time_order_needed: boolean
    new_buyer_abuse_checker: boolean
    milestone: {
      start_date_time: string
      end_date_time: string
      enable: boolean
      type: string
    }
    ab_test: {
      enable: boolean
      total_variant: number
      variant_percentages: number[]
    }
    is_clevertap_needed: boolean
    is_customer_preference_needed: boolean
  }
}

export type PostCreateSegmentResponseType = {
  error: {
    code: number
    status: boolean
    message: string
  }
  data: {
    message: string
  }
}

export const postCreateSegment = ({ data }: PostCreateSegmentRequestType) =>
  Post<PostCreateSegmentResponseType, true>({
    url: `/segmentation/internal/v2/segment`,
    data,
  })

export type PutUpdateSegmentRequestType = {
  segmentId: string
  data: PostCreateSegmentRequestType['data']
}

export const putUpdateSegment = ({ segmentId, data }: PutUpdateSegmentRequestType) =>
  Put<{ message: string }>({
    url: `/segmentation/internal/v2/segment/${segmentId}`,
    data,
  })

export const putUpdateSegmentAB = ({ segmentId, data }: PutUpdateSegmentRequestType) =>
  Put<{ message: string }>({
    url: `/segmentation/internal/v2/segment/ab-group/${segmentId}`,
    data,
  })
